module.exports = __webpack_public_path__ + "static/media/icon-character__stefan-zweig.848550f6.svg";